import cn from "classnames";

import { HabitIcon } from "@/components/ui/habit-icon";
import { ICONS } from "@/components/ui/icon-catalog";

import styles from "./icon-picker.module.scss";

export { ICONS };

interface IconPickerProps {
  value: string;
  onChange: (icon: string) => void;
}

export function IconPicker({ value, onChange }: IconPickerProps) {
  return (
    <div className={styles.grid} role="radiogroup" aria-label="Choose icon">
      {ICONS.map(({ emoji, label }) => (
        <button
          key={emoji}
          type="button"
          className={cn(styles.icon, value === emoji && styles.selected)}
          onClick={() => onChange(emoji)}
          role="radio"
          aria-checked={value === emoji}
          aria-label={label}
        >
          <HabitIcon value={emoji} size={32} />
        </button>
      ))}
    </div>
  );
}
